import React from 'react';

import { AdaptiveSingleLineText, Icons, Tooltip } from '@components/common';

import styles from './SystemFieldName.module.scss';

interface IAssetAttributeProps {
	name: string;
	isRequired?: boolean;
	tooltipText: string;
}

const SystemFieldName = ({
	name,
	isRequired = false,
	tooltipText,
}: IAssetAttributeProps) => (
	<div className={styles.systemFieldName}>
		<AdaptiveSingleLineText
			className={styles.nameText}
			maxWidth={170}
			paddingsSize={0}
			text={name}
		/>
		{isRequired &&
			<div
				className={styles.required}
				data-testid='required-indicator'
			/>
		}
		&nbsp;
		<Tooltip content={tooltipText}>
			<div>{Icons.info()}</div>
		</Tooltip>
	</div>
);

export default SystemFieldName;
